<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getAboutData)" class="refresh-btn">刷新</el-button>
    <div class="wrap" v-loading="loading">
		<WEditor :defaultText="defaultText" :richText.sync="richText" />
		<div class="btnwrap">
			<el-button @click="save" type="success">保存修改</el-button>
			<el-button @click="$refresh(getAboutData)">取消修改</el-button>
		</div>
    </div>
  </div>
</template>
 
<script lang="js">
import WEditor from "@/components/WEditor"; // 引入封装好的编辑器
import { getAbout, editAbout } from "@/api/aboutus"; // 引入关于我们请求
export default {
	name: "Editor",
	components: { WEditor },
	data() {
		return {
			defaultText: '', // 富文本默认值
			richText: "", // 富文本更新值
			loading: true,
			searchForm: {}
		};
	},
	created() {
		// 等待组件加载完毕赋值
		this.$nextTick(() => { this.defaultText = "" });
		this.getAboutData();
	},
	methods: {
		// 获取数据
		async getAboutData() {
			let { code, data } = await getAbout();
			if (code == 200) this.defaultText = data.replace(/\\/g,'');
			this.loading = false;
		},
		// 保存
		async save() {
			let { code } = await editAbout({ value: this.richText});
			if (code == 200) {
				this.$message.success("保存成功！");
				this.$refresh(this.getAboutData);
			}
		}
	}
};
</script>

<style lang="less">
#w_view {
  height: 750px;
  display: flex;
  flex-direction: column;
  .w-e-text-container {
		height: 708px!important;
  }
}
</style>
<style lang="less" scoped>
.wrap {
	position: relative;
	.btnwrap {
		position: absolute;
		right: 10px;
		top: 5px;
		z-index: 100000;
	}
}
</style>